import { render, staticRenderFns } from "./AccountCompany.vue?vue&type=template&id=835465f2&"
import script from "./AccountCompany.vue?vue&type=script&lang=js&"
export * from "./AccountCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('835465f2')) {
      api.createRecord('835465f2', component.options)
    } else {
      api.reload('835465f2', component.options)
    }
    module.hot.accept("./AccountCompany.vue?vue&type=template&id=835465f2&", function () {
      api.rerender('835465f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/components/AccountCompany.vue"
export default component.exports